import "./code-block/code-block.js";
import "./property-search.js";
import "./sidebar-popover.js";

import { TemplateElement } from "@microsoft/fast-html";

TemplateElement.define({ name: "f-template" });
